import type { SxProps, Theme } from '@mui/material';

export const popupActionButtonSx = {
  height: '32px',
  minHeight: '32px',
  padding: '6px 16px',
  borderRadius: '4px',
  fontSize: '14px',
  fontWeight: 600,
  lineHeight: '24px',
  fontFamily: 'Poppins, sans-serif',
  textTransform: 'none',
  boxShadow: 'none',
  backgroundImage: 'linear-gradient(90.0556deg, #092056 0%, #00A5FF 99.972%)',
  color: '#FFFFFF',
  '&:hover': {
    backgroundImage: 'linear-gradient(90.0556deg, #092056 0%, #00A5FF 99.972%)',
  },
} satisfies SxProps<Theme>;

export const popupSecondaryButtonSx = {
  height: '32px',
  minHeight: '32px',
  padding: '6px 8px',
  borderRadius: '4px',
  fontSize: '14px',
  fontWeight: 600,
  fontFamily: 'Poppins, sans-serif',
  textTransform: 'none',
  color: '#00A5FF',
  background: 'transparent',
  boxShadow: 'none',
  '&:hover': {
    background: 'transparent',
    color: '#092056',
  },
} satisfies SxProps<Theme>;
